"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hiddenElement = _interopRequireDefault(require("../../../Structural/hiddenElement"));

var _colors = require("../../../../styles/colors");

var _borderRadius = require("../../../../styles/borderRadius");

var _margins = require("../../../../styles/margins");

var _shadows = require("../../../../styles/shadows");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    & ~ label > .rainbow-input_faux {\n        width: 20px;\n        height: 20px;\n        display: inline-block;\n        position: relative;\n        vertical-align: middle;\n        border: ", ";\n        border-radius: ", ";\n        background: ", ";\n        margin-right: ", ";\n        transition: border 0.1s linear, background-color 0.1s linear;\n    }\n\n    :checked ~ label > .rainbow-input_faux::after {\n        display: block;\n        content: '';\n        height: 0.4rem;\n        width: 0.65rem;\n        position: absolute;\n        top: 46%;\n        left: 50%;\n        transform: translate3d(-50%, -50%, 0) rotate(-45deg);\n        border-bottom: 2px solid;\n        border-left: 2px solid;\n        border-color: ", ";\n    }\n\n    :checked ~ label > .rainbow-input_faux {\n        border: 2px solid;\n        border-color: ", ";\n    }\n\n    :focus ~ label > .rainbow-input_faux {\n        content: '';\n        border: 2px solid;\n        border-color: ", ";\n        box-shadow: ", ";\n    }\n\n    &[disabled] ~ label > .rainbow-input_faux {\n        background-color: ", ";\n        border-color: ", ";\n    }\n\n    &[disabled] ~ label > .rainbow-input_faux::after {\n        border-color: ", ";\n    }\n\n    :focus:checked ~ label > .rainbow-input_faux {\n        border-color: ", ";\n        background-color: ", ";\n        box-shadow: ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function getInitialBorder(props) {
  if (props.error) {
    return "2px solid ".concat(_colors.COLOR_ERROR);
  }

  return "1px solid ".concat(_colors.COLOR_GRAY_2);
}

function getColor(props) {
  if (props.error) {
    return _colors.COLOR_ERROR;
  }

  return _colors.COLOR_BRAND;
}

function getShadow(props) {
  if (props.error) {
    return _shadows.SHADOW_ERROR;
  }

  return _shadows.SHADOW_OUTLINE;
}

var Checkbox = (0, _styledComponents["default"])(_hiddenElement["default"])(_templateObject(), getInitialBorder, _borderRadius.BORDER_RADIUS_3, _colors.COLOR_WHITE, _margins.MARGIN_SMALL, getColor, getColor, getColor, getShadow, _colors.COLOR_GRAY_1, _colors.COLOR_GRAY_2, _colors.COLOR_WHITE, getColor, _colors.COLOR_WHITE, getShadow);
var _default = Checkbox;
exports["default"] = _default;